export const suppressedSubBrandsContainsLogic = [
  'MILWAUKEE',
  'RIDGID',
  'RYOBI',
  'HACKZALL',
  'HOLE HAWG',
  'M12',
  'M12FUEL',
  'M18',
  'M18FUEL',
  'MX FUEL',
  'ONE KEY',
  'ONE-KEY',
  'PACK OUT',
  'PACKOUT',
  'REDLITHIUM',
  'SAWZALL',
  'SUPER HAWG',
  'SWITCHBLADE',
  'MAX OUTPUT',
  'MSUV',
  'STEALTHFORCE',
  'AIRCANNON',
  'AIRSTRIKE',
  'CORNERCAT',
  'EASYCLEAN',
  'EDGE BATTERY',
  'EXPAND-IT',
  'EZ CLEAN',
  'LITHIUM EDGE',
  'ONE PLUS',
  'ONE+',
  'REEL EASY',
  'SPEEDBENCH',
  'SWIFTCLEAN',
  'USB LITHIUM'
];
